<script>
import appConfig from "@/app.config";

import InvoicesListe from "@/components/invoices-list"

import CustomersApi from "@/services/customers-api";

export default {
  page: {
    title: "Documents",
    meta: [{ name: "description", content: appConfig.description }]
  },

  props: {
        api:{
          type:Function,
          default: null
        },
        withHoldingColumn:{
          type:Boolean,
          default: false
        },
        isBlList:{
          type:Boolean,
          default: false
        },
        isAvoirList:{
          type:Boolean,
          default: false
        },

        isInvoiceList:{
          type:Boolean,
          default: false
        },
        isConsigneList:{
          type:Boolean,
          default: false
        },

        displayExport:{
          type:Boolean,
          default: false
        },

        displayAccusedModal:{
          type:Boolean,
          default: false
        },
        isAvoirDetailsButton:{
          type:Boolean,
          default: false
        },
        withClaim:{
          type:Boolean,
          default: false
        },
      },

  mounted(){

    //this.role=sessionStorage.getItem("userr");
    if(this.role==1){
      this.getCustomers()
    }
    this.findAccessibleAgencyCurrentCustomer()
    
    
  },
  computed: {

    filterByAllAgency() {
      return this.allAgencyList && this.allAgencyList.length > 1;
    },

    allAgencyList() {
      try {
        return JSON.parse(process.env.VUE_APP_FEATURE_AGENCY_LIST || "[]");
      } catch (e) {
        return [];
      }
    },


        filterByAgency() {
          return this.agencyList && this.agencyList.length > 1;
        },

        role() {
          return this.$cookies.get('userr');
        },

        isAdmin() {
          return this.$cookies.get('userr') == 1;
        },
      statusOptions() {
        const allOptions = [
          { name: this.$t('avoir.statusLabel.DRAFT'), value: 0 },
          { name: this.$t('avoir.statusLabel.PENDING'), value: 1 },
          { name: this.$t('avoir.statusLabel.VALIDATE'), value: 2 },
        ];
        if (this.role !== 0) {
          return allOptions.filter(opt => opt.value !== 0 );
        }
        return allOptions;
      },

      invoiceTypeOptions() {
        return [
          { name: this.$t('ordersMenu.pharma'), value: 'PHARMA' },
          { name: this.$t('ordersMenu.para'), value: 'PARA' },
        ];
      },

      isParaOnly(){
        return  process.env.VUE_APP_FEATURE_PARA_ONLY === 'true'
      },

      customerCategory(){
        return this.$cookies.get('custCat');
      },

      initialType(){
        if (this.isParaOnly) return 'PARA'
        // Factures: every invoice until the user picks a Type (no docType is sent to the list and the export)
        if (this.isInvoiceList) return null
        // BL / Avoirs radios need a company: PARA only for a known Para customer (category 1),
        // PHARMA otherwise (suppliers, admins, sessions without the custCat cookie, clinics)
        return this.customerCategory == 1 ? 'PARA' : 'PHARMA'
      }
    },
  components: {InvoicesListe},

  created() {
    this.type = this.initialType
  },
  
  data() {
    return {
     // role:null,
      type: null,
      selectedState:null,
      status:null,
      customersList:[],
      selectedCustomer:null,
      selected:null,
      start:null,
      end:null,
      exportInvoicesInProgress : false,
      showAddNewAvoirModal: false ,
      agencyList:[],
      agencySelected:null,
      accessibleAgencyCurrentCustomer:null
    };
  }, 

  methods:{

    findAccessibleAgencyCurrentCustomer(){

      if(this.role != 0){
        return
      }

      CustomersApi.findAccessibleAgencyCurrentCustomer()      
      .then(
        (result)=>{
          if(result){

              this.accessibleAgencyCurrentCustomer = result
              this.agencyList = result.agenceSecondary || []
              this.agencySelected = result.agenceSecondary.find(o => o.id === result.agence);
            }
        }
      ).finally(() => {
        this.isSimilairItemsTableBusy = false;

      })
    },

    addNewAvoir() {
      this.$refs.invoicesList.showAvoirModal();
    },

    onCloseAddNewAvoirModal(){
      this.showAddNewAvoirModal= false;
    },

    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
        response => {
          if(response && response.length > 0){
            this.customersList=response;
            if(this.role == 1 && (this.isBlList || this.isAvoirList || this.isConsigneList)  ){
              this.selected = this.customersList[0]
              this.selectedCustomer = this.customersList[0].id
            }
          }
        }
      )
    },

    exportEXCEL(){
      this.exportInvoicesInProgress = true;
      this.$refs.invoicesList.exportInvoicesListExcel()
      .then(() => {
           this.exportInvoicesInProgress = false;
        })
      
    },

  },
    watch: {
        selected: function() {
            this.selectedCustomer = this.role == 1 ? 
              this.selected ? this.selected.id :   
                this.isBlList || this.isAvoirList || this.isConsigneList ? this.customersList[0].id : null 
                : null;
            this.selected = this.role == 1 ? 
              this.selected ? this.selected : 
                this.isBlList || this.isAvoirList || this.isConsigneList ? this.customersList[0] : null
                : null;
        },

        selectedState: function() {
            this.status = this.selectedState ? this.selectedState.value : null
        },

        start: function(){
        },

        end: function(){
        },

        agencySelected: function(){

          if(this.agencySelected == null && this.accessibleAgencyCurrentCustomer != null && this.accessibleAgencyCurrentCustomer.agenceSecondary.length){
              this.agencySelected = this.accessibleAgencyCurrentCustomer.agenceSecondary.find(
                    o => o.id === this.accessibleAgencyCurrentCustomer.agence
                )
          }

        }


    }       
    }

</script>

<style>
  .style-vselect .vs__search {
    line-height: 1;
    color: #394066;
    font-size: 1em
  }

</style>

<template>
  <div>

    <div v-if="!isParaOnly && (isBlList || isAvoirList)">

      <div class="row mt-5 mb-3">
          <div class="col-12">

            <b-form-radio
                  class="custom-radio custom-radio custom-radio-primary mb-3"
                  value="PHARMA" 
                  v-model="type"><span :class="type === 'PHARMA' ? 'text-primary font-weight-bold' : ''">
                    {{ $t('ordersMenu.pharma') }}</span>
                </b-form-radio> 
            
            <b-form-radio
                class="custom-radio custom-radio custom-radio-primary mb-3"
                value="PARA"
                v-model="type"><span :class="type === 'PARA' ? 'text-primary font-weight-bold' : ''">{{ $t('ordersMenu.para') }}</span>
              </b-form-radio> 

                
          </div>
        </div>
    </div>

   
  <div v-if="displayExport" class="row mt-0">
    <div class="col-sm-12 text-right" >
      <b-form-group label="_" class="text-white" label-for="">
        <b-button v-if="displayExport" variant="success" @click.prevent="exportEXCEL()" :disabled="exportInvoicesInProgress">
          <b-spinner small :class="exportInvoicesInProgress ? 'mr-1' : 'd-none'"></b-spinner>
          <i class="fas fa-file-excel text-white font-size-16 m-0 p-0 font-weight-bold align-middle mr-2"></i> 
          <span class=" font-weight-bold text-white text-uppercase">{{$t('invoicesMenu.export')}} </span>
      </b-button>
      </b-form-group>
    </div>

  </div>
  <div v-if="isAvoirDetailsButton && this.role == 0" class="row mt-2">
    <div class="col-sm-12 text-right" >
      <b-form-group label="_" class="text-white" label-for="">
        <b-button v-if="isAvoirDetailsButton && this.role == 0" variant="success"  @click="addNewAvoir()" >
          <b-spinner small :class="exportInvoicesInProgress ? 'mr-1' : 'd-none'"></b-spinner>  
          <i class=" fas fa-plus-square text-white font-size-16 m-0 p-0 font-weight-bold align-middle mr-2"></i> 
          <span class=" font-weight-bold text-white text-uppercase">{{$t('avoir.newAvoir.newAvoirButton')}} </span>
      </b-button>
      </b-form-group>
    </div>

  </div>

   <div  class="row mt-2">

            <div v-if="role==1 && ( isBlList || isAvoirList) && filterByAllAgency" class="col-md-3 col-xs-12 pr-md-4">
              <b-form-group
                :label="$t('lists.agency.filter')"
                label-for="agency-filter"
                >
                <v-select
                    id="agency-filter"
                    class="style-vselect-big"
                    style="font-size:1.2em;"
                    :options="allAgencyList"
                    :placeholder="$t('lists.agency.label')"
                    label="name"
                    v-model="agencySelected"
                >
                    <span slot="no-options">
                    {{$t('lists.emptyLists.label')}}
                    </span>
                </v-select>
              </b-form-group>
            </div>
          
            <div v-else-if="role == 0 && (isBlList || isAvoirList)" class="col-md-3 col-xs-12 pr-md-4">
              <b-form-group v-if="this.filterByAgency"
                :label="$t('lists.agency.filter')"
                label-for="agency-filter"
                >
                <v-select
                    id="agency-filter"
                    class="style-vselect-big"
                    style="font-size:1.2em;"
                    :options="agencyList"
                    :placeholder="$t('lists.agency.label')"
                    label="name"
                    v-model="agencySelected"
                >
                    <span slot="no-options">
                    {{$t('lists.emptyLists.label')}}
                    </span>
                </v-select>
              </b-form-group>
            </div>


          <div  v-if="role==1" class="col-md-3 col-xs-12 pr-md-4">
            <b-form-group :label="$t('lists.customers.filter')" label-for="">
              <v-select class="style-vselect-big" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selected">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
              </v-select>
            </b-form-group>
          </div>
          

            <div v-if="!isConsigneList" class="col-md-3 col-xs-12 pr-md-4">
              <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"  label-for="">
                  <b-form-datepicker
                  v-model="start"
                  :locale="$t('datPicker.locale')"
                  :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                  dark
                  reset-button
                  close-button
                  :label-reset-button="$t('datPicker.label-reset-button')"
                  :label-close-button="$t('datPicker.label-close-button')"
                  dropright
                  hide-header
                  ></b-form-datepicker>
              </b-form-group>
            </div>
            <div v-if="!isConsigneList" class="col-md-3 col-xs-12 pr-md-4">
              <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')" label-for="">
                  <b-form-datepicker
                  v-model="end"
                  :locale="$t('datPicker.locale')"
                  :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                  dark
                  reset-button
                  close-button
                  :label-reset-button="$t('datPicker.label-reset-button')"
                  :label-close-button="$t('datPicker.label-close-button')"
                  dropright                         
                  hide-header
                  ></b-form-datepicker>
              </b-form-group>
            </div>

            <div v-if="isInvoiceList && !isParaOnly && !isConsigneList" class="col-md-3 col-xs-12 pr-md-4">
              <b-form-group label="Type" label-for="">
                <v-select
                  v-model="type"
                  class="style-vselect-big"
                  style="font-size:1.2em;"
                  :options="invoiceTypeOptions"
                  label="name"
                  :reduce="option => option.value"
                  placeholder="Type"
                  :searchable="false"
                >
                  <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
              </b-form-group>
            </div>

            <div v-if="isAvoirDetailsButton" class="col-12 col-md-3 ">
              <b-form-group :label="$t('avoir.filter')"  label-for="" >
                  <v-select class="style-vselect-big" style="font-size:1.2em;" 
                  :options="statusOptions"
                  :placeholder="$t('lists.status.label')" label="name" v-model="selectedState" :searchable="false">
                  <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                  </v-select>
              </b-form-group>
            </div>
            <div v-if="role!=1" class="col-md-3 col-xs-12 pr-md-4" />

            <!-- <div v-if="role==1" class="col-md-3 col-xs-12">
                <b-form-group :label="$t('lists.customers.filter')" label-for="">
                    <v-select class="style-vselect-big" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selected">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
                </div> -->
        </div>
  
  <InvoicesListe 
    :withClaim="this.withClaim"  
    ref="invoicesList" 
    :api="this.api" 
    :isAvoirList="isAvoirList" 
    :isInvoiceList="isInvoiceList" 
    :isConsigneList="isConsigneList" 
    :isBlList="isBlList" 
    :type="type" 
    :displayAccusedModal="this.displayAccusedModal" 
    :isAvoirDetailsButton="this.isAvoirDetailsButton" 
    :withHoldingColumn="this.withHoldingColumn"  
    :status.sync=this.status 
    :customerId.sync=this.selectedCustomer  
    :start.sync=start 
    :end.sync=end  
    :agencySelected.sync="agencySelected == null ? null : agencySelected.id"
  />
  </div>
</template>